import styled from 'styled-components';

export const BadgeStyle = styled.div`
  .badgeDiv {
    width: 100%;
    height: 100%;
  }
`;
